export const Alpha10 = '19';
export const Alpha30 = '4C';
export const Alpha50 = '7F';
export const Primary50 = '#EFEBE9';
export const Primary100= '#D7CCC8';
export const Primary200= '#BCAAA4';
export const Primary300= '#A1887F';
export const Primary400= '#8D6E63';
export const Primary500= '#795548';
export const Primary600= '#6D4C41';
export const Primary700= '#5D4037';
export const Primary800= '#4E342E';
export const Primary900= '#3E2723';

export const Secondary50= '#E3F2FD';
export const Secondary100= '#BBDEFB';
export const Secondary200= '#90CAF9';
export const Secondary300= '#64B5F6';
export const Secondary400= '#42A5F5';
export const Secondary500= '#2196F3';
export const Secondary600= '#1E88E5';
export const Secondary700= '#1976D2';
export const Secondary800= '#1565C0';
export const Secondary900= '#0D47A1';
export const SecondaryA100= '#82B1FF';
export const SecondaryA200= '#448AFF';
export const SecondaryA400= '#2979FF';
export const SecondaryA700= '#2962FF';


export const Grey50= '#FAFAFA';
export const Grey100= '#F5F5F5';
export const Grey200= '#EEEEEE';
export const Grey300= '#E0E0E0';
export const Grey400= '#BDBDBD';
export const Grey500= '#9E9E9E';
export const Grey600= '#757575';
export const Grey700= '#616161';
export const Grey800= '#424242';
export const Grey900= '#212121';

export const Black= '#212121';
export const White= '#FFFFFF';
export const Yellow = '#FBC02D';
export const Green = '#80CE7A';


export const DarkPrimaryColor = Primary700;
export const DefaultPrimaryColor = Primary500;
export const LightPrimaryColor =  Primary50;
export const AccentColor = Secondary500;
export const DarkAccentColor = Secondary700;
export const LightAccentColor = Secondary50;
export const OnPrimary = White;
export const PrimaryTextColor = Black;
export const OnPrimaryVariant = PrimaryTextColor + Alpha50;
export const OnAccentColor = White;
export const SurfaceColor = White;
export const OnSurface = PrimaryTextColor;
export const OnSurfaceVariant = OnSurface + Alpha50;
export const BackgroundColor = Grey200;
export const DividerColor =  Grey400;
export const ShadowColor = Black + Alpha30;

export const DisableColor = Black+Alpha50;
export const Success = Green;
export const HoverColor = Grey100;
export const ErrorColor = 'red';

export const ScoreColor = (pcnt) => {
	if(pcnt>0.5) return 'green';
	if(pcnt<0.3) return 'crimson';
	return 'darkorange';
}

export const ColorDefs = {
	primary : 'colorPrimary',
	secondary : 'colorSecondary',
	default : 'colorDefault'
};
